import * as z from "zod/mini";

export const companyDetectionSchema = z
  .object({
    idCompany: z.nullable(z.optional(z.string())),
    inscriptionCountry: z.nullable(z.optional(z.string())),
    inscriptionNumber: z.nullable(z.optional(z.string()))
  })
  .check(
    z.refine(
      (schema) => {
        if (!schema.inscriptionNumber) return true;
        return (
          schema.inscriptionCountry !== null &&
          schema.inscriptionCountry !== undefined &&
          schema.inscriptionCountry !== ""
        );
      },
      {
        message: "error inscriptionCountry",
        path: ["inscriptionCountry"]
      }
    )
  );
